import React, { Component } from 'react';
import _ from 'lodash'

class LinkCell extends Component {

    getTextForList(list, title) {
        if (list && !_.isEmpty(list)) {
            return list.map((item) => {
                return <div>{title + item.payable.publicId + ": " + new Intl.NumberFormat("hu-HU").format(item.amount)}</div>;
            })
        } else {
            return "";
        }
    }

    getTextForMap(m) {
        //console.log(typeof (m))
        //console.log(m['INCOMING_BILL'])
        let incomingBills = this.getTextForList(m['INCOMING_BILL'], "Bejövő: ");
        let outgoingBills = this.getTextForList(m['OUTGOING_BILL'], "Kimenő: ");
        let salaries = this.getTextForList(m['SALARY'], "Fizetés: ");
        let taxes = this.getTextForList(m['TAX'], "Adó: ");
        let restrains = this.getTextForList(m['RESTRAIN'], "Letiltás: ");
        let dividens = this.getTextForList(m['DIVIDEND'], "Osztalék: ");
        return <div>{incomingBills}{outgoingBills}{salaries}{taxes}{restrains}{dividens}</div>
        // let result = "";
        // if (incomingBills && !_.isEmpty(incomingBills)) {
        //     result = result.concat("Bejövő: " + incomingBills);
        // }
        // if (outgoingBills && !_.isEmpty(outgoingBills)) {
        //     result = result.concat("Kimenő: " + outgoingBills);
        // }
        // if (salaries && !_.isEmpty(salaries)) {
        //     result = result.concat("Fizetés: " + salaries);
        // }
        // if (taxes && !_.isEmpty(taxes)) {
        //     result = result.concat("Adó: " + taxes);
        // }
        // if (restrains && !_.isEmpty(restrains)) {
        //     result = result.concat("Letiltás: " + restrains);
        // }
        // return result;
    }

    render() {
        return (
            <>

                {this.props.row.linked.map && !_.isEmpty(this.props.row.linked.map) ?
                    <span>{this.getTextForMap(this.props.row.linked.map)}</span> : <></>}
            </>
        )
    }
}
export default LinkCell;